import styled from "styled-components";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { TrackSectionEntityCardContainer } from "./TrackSectionEntityCardContainer";

const TitleSkeleton = styled(PixelPlaceholderLoader)`
    border-radius: 2px;
`;

const SubtitleSkeleton = styled(PixelPlaceholderLoader)`
    border-radius: 2px;
`;

const ChipSkeleton = styled(PixelPlaceholderLoader)`
    border-radius: 999px;
`;

const SparklineSkeleton = styled(PixelPlaceholderLoader)`
    border-radius: 2px;
`;

export const TrackSectionEntityCardSkeleton = () => {
    return (
        <TrackSectionEntityCardContainer isInteractive={false}>
            <TrackSectionEntityCardContainer.IconBox />
            <TrackSectionEntityCardContainer.TitleGroup gap="4px">
                <TitleSkeleton
                    width={185}
                    height={16}
                />
                <SubtitleSkeleton
                    width={80}
                    height={10}
                />
            </TrackSectionEntityCardContainer.TitleGroup>
            <TrackSectionEntityCardContainer.TrendGroup>
                <ChipSkeleton
                    width={64}
                    height={24}
                />
                <SparklineSkeleton
                    width={96}
                    height={32}
                />
            </TrackSectionEntityCardContainer.TrendGroup>
        </TrackSectionEntityCardContainer>
    );
};
